
import { Component, Vue, Watch } from "vue-property-decorator"
import { Getter } from "vuex-class"
// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"

import { CaseDetails, SearchClause, DataType, dataTypeByFieldType, CalculationType } from "@/types"
import { PagedData } from "@/types/pagedData"
import { caseColumns, CaseColumn } from "@/types/caseColumns"

import api from "@/services/api"

import UserImage from "@/components/UserImage.vue"
import ResultsDisplay from "@/components/Search/ResultsDisplay.vue"
import CasePreview from "@/components/Search/CasePreview.vue"
import SkeletonLoader from "@/components/SkeletonLoader.vue"
import PageWrapper from "@/components/New/Page/PageWrapper.vue"

@Component({
	components: {
		"page": PageWrapper,
		"skeleton": SkeletonLoader,
		"user-image": UserImage,
		"scrollbar": VuePerfectScrollbar,
		"case-results": ResultsDisplay,
		"case-preview": CasePreview
	}
})
export default class Search extends Vue {
	$refs!: {
		caseSearch: ResultsDisplay;
		peopleSearch: ResultsDisplay
	}

	@Getter getSearch!: string;

	search: string = "";
	searching: boolean = false;

	caseColumns: CaseColumn[][] = [];
	caseDefaultColumns = [
		"caseNumber", "title", "templateTitle", "created", "lastUpdated", "statusTitle", "assigneeId", "templateId"
	];
	caseResults: PagedData<any> | null= null;

	userColumns: any[][] = [];
	userDefaultColumns = [
		"name", "pictureUrl", "teams", "email"
	];
	userResults: PagedData<any> | null = null;

	locationResults: any[] | null= null;

	perPage: number = 50; // default to 50 results per page

	previewCase: CaseDetails | null = null;

	clauses: SearchClause[] = [];

	public created () {
		this.caseColumns = []
		this.caseColumns.push(caseColumns)

		this.userColumns = [
			[
				{
					key: "name",
					label: "Name",
					dataType: "user-picture"
				},
				{
					key: "email",
					label: "Email",
					dataType: "text"
				},
				{
					key: "teams",
					label: "Roles",
					dataType: "list-multiple",
					listLabel: "title",
					columnValues: (api: any) => api.teamsGet()
				}
			]
		]
	}

	public async mounted () {
		this.caseColumns = []
		this.caseColumns.push(caseColumns)

		this.search = this.getSearch

		this.caseColumns.push((await api.fields()).map(field => {
			let result = {
				key: "fields." + field.id,
				label: field.title,
				dataType: field.dataType,
				fieldDataType: dataTypeByFieldType[field.dataType!],
				fieldId: field.id,
				dataSourceId: field.dataSourceId,
				columnListLabel: "label",
				dynamicField: true
			} as CaseColumn

			// For calculated field type - CalculationType.AddToDate
			if (field.dataType === "calculated" && field.extensions && field.extensions.calculationType === CalculationType.AddToDate) {
				result.fieldDataType = DataType.dateTime
			}

			return result
		}))

		// Do not display the calculated field type - CalculationType.DaysUntilOrFromToday
		if (this.caseColumns[1]) {
			this.caseColumns[1].forEach((item, index, array) => {
				if (item.label === "days until or from today") {
					array.splice(index, 1)
				}
			})
		}

		if (this.search) {
			this.doSearch()
		}
	}

	@Watch("getSearch")
	onGetSearchChanged (newSearch: string) {
		if (newSearch && newSearch !== this.search) {
			this.search = this.getSearch
			this.doSearch()
		}
	}

	public async doSearch () {
		this.searching = true

		try {
			await Promise.all([
				this.$refs.caseSearch.search(),
				this.$refs.peopleSearch.search()
			])
		} finally {
			this.searching = false
		}
	}

	public setPreviewCase (caseDetails: CaseDetails) {
		this.previewCase = null
		setTimeout(() => {
			this.previewCase = caseDetails
		}, 500)
	}

	public gotoPreviewCase (): void {
		if (this.previewCase) {
			this.$router.push({ path: `/cases/${this.previewCase.caseNumber}` })
		}
	}
}

